import React from 'react';

export default function DataTableState({
  state = 'empty',
  message,
  className = '',
}) {
  const toneClass = {
    loading: 'text-[#8ea3bd]',
    empty: 'text-[#7f93ac]',
    error: 'text-[#ff9d9d]',
  };
  return (
    <div className={`rounded-xl bg-[#0b1422] px-4 py-8 text-center text-sm ${toneClass[state] || toneClass.empty} ${className}`}>
      {message}
    </div>
  );
}
